module.exports = __webpack_public_path__ + "static/media/p1.3a62b03e.png";